// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEND = "Odo\u0161li";
export const SEO_TITLE_FAQ_ASK_QUESTION = "Nap\u00ed\u0161 n\u00e1m";
